// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".product_input__jetMd {\n  outline: none;\n}\n.product_input__jetMd[type=number]::-webkit-inner-spin-button, .product_input__jetMd[type=number]::-webkit-outer-spin-button {\n  opacity: 1;\n}", "",{"version":3,"sources":["webpack://./src/component/app/product/product.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AAAE;EAEE,UAAA;AACJ","sourcesContent":[".input {\n  outline: none;\n  &[type=\"number\"]::-webkit-inner-spin-button,\n  &[type=\"number\"]::-webkit-outer-spin-button {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": "product_input__jetMd"
};
export default ___CSS_LOADER_EXPORT___;
